<template>
  <section class="section" id="home-section">
    <!-- Main Image -->
    <div class="grid-item" style="margin-bottom: 10px">
      <img :src="mainImage" alt="Rubik's Cube Guide" />
    </div>

    <!-- Instructions Text -->
    <div class="grid-item" style="margin-bottom: 10px; margin-top: 10px">
      <div class="exampleText">
        <p>OLL and PLL is vertical view</p>
        <p>OLL: The black bars and square represent the yellow pieces</p>
        <p>PLL: The black bars represent the same colored pieces</p>
      </div>
      <div>
        <a href="#f2l-section">Go to F2L</a><br />
        <a href="#oll-section">Go to OLL</a><br />
        <a href="#pll-section">Go to PLL</a>
      </div>
    </div>

    <!-- Image Grid -->
    <div class="grid-container7">
      <div class="grid-item" v-for="img in gridImages" :key="img.id">
        <img :src="img.src" :alt="`Guide image ${img.id}`" />
      </div>
    </div>

    <!-- Notation Guide -->
    <div
      class="grid-item exampleTextNormal"
      style="margin-bottom: 10px; margin-top: 10px"
    >
      <p>
        Lowercase: Turn 2 Layers,
        <b>x (R), y (U), z (F)</b>: Whole rotation<br />
        Letter+ ': Turn 90° counterclockwise<br />
        Letter+2: Turn 180° clockwise<br />
        Letter+'2: Turn 180° counterclockwise
      </p>
    </div>

    <!-- Color Guide -->
    <div class="grid-item" style="margin-bottom: 10px">
      <p>
        <span style="color: #0075ce">Blue font: By left index finger</span
        ><br />
        <span style="color: #e50012">Red font: By right thumb</span><br />
        <span style="color: #ef8200">Orange font: By right ring finger</span>
      </p>
    </div>

    <!-- Movement Notation -->
    <div class="grid-item exampleTextNormal" style="margin-bottom: 10px">
      <p>
        (): A series of movements<br />
        ()+2: Repeat the same series of movements once. e.g<br />
        (R U R' <span class="mainColor2">U'</span>)2=(RU R'
        <span class="mainColor2">U'</span>)(R U R'
        <span class="mainColor2">U'</span>)
      </p>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';

// Main image
const mainImage = computed(() => {
  return require('../rubik/images/img1.png');
});

// Grid images (img2 through img22)
const gridImages = computed(() => {
  const images = [];
  for (let i = 2; i <= 22; i++) {
    images.push({
      id: i,
      src: require(`../rubik/images/img${i}.png`),
    });
  }
  return images;
});
</script>

<style scoped>
.section {
  margin: 0 auto 20px;
  padding: 16px 0px;
}

.grid-item {
  background-color: #f4fbfe;
  padding: 10px;
  text-align: center;
  color: #f08200;
  border: 2px solid #f08200;
  font-weight: bold;
  border-radius: 6px;
  margin-bottom: 10px;
}

.grid-item img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.grid-container7 {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 10px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  letter-spacing: 3px;
  margin-bottom: 10px;
}

.exampleText {
  color: black;
  margin-bottom: 10px;
}

.exampleText p {
  margin: 5px 0;
}

.exampleTextNormal {
  color: black;
  font-weight: normal;
}

.exampleTextNormal p {
  margin: 5px 0;
}

.mainColor2 {
  color: #0075ce;
}

@media (max-width: 1024px) {
  .grid-container7 {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 768px) {
  .grid-container7 {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 480px) {
  .grid-container7 {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Links - always orange and underlined */
a {
  color: #f08200;
  text-decoration: underline; /* Changed from 'none' to 'underline' */
  font-size: 16px;
}

a:hover {
  text-decoration: underline;
  color: #f08200; /* Keep orange on hover */
}
</style>
